<template>
    <div class="tournaments-primary-container">
        <div class="tabs-view-container">
            <div class="mobile-prev-button" @click="show_tournaments_list=true;">
                <div class="prev-button"></div>
            </div>
            <div class="tabs-wrapper-view">
                <div class="tabs-view">
                    <div class="tab" :class="{'active':archived==false}" @click="archived=false;show_tournaments_list=true;">
                        <span>Curente</span>
                    </div>
                    <div class="tab" :class="{'active':archived==true}" @click="archived=true;show_tournaments_list=true;">
                        <span>Arhivate</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="tournaments_container" :class="{'list-displayed':show_tournaments_list}">
            <template v-if="!is_loading">
                <template v-if="tournaments.length>0">
                    <div class="tournaments_list">
                        <div class="tournament" v-for="(tournament,index) in tournaments" :class="{'selected':tournament.id==selected}" @click="selected=tournament.id;show_tournaments_list=false;">
                            <div class="t-date">
                                <h2>{{tournament.date.d}}</h2>
                                <h4>{{$t("strings.MONTH_SHORT_"+parseInt(tournament.date.m))}}</h4>
                            </div>
                            <div class="t-descrption">
                                <p class="t-name">{{tournament.name}}</p>
                                <p class="t-locuri">{{tournament.seats.free}} Locuri disponibile</p>
                            </div>
                        </div>
                    </div>
                    <div class="tournaments-description-container">
                        <div class="tournaments_desctription">
                            <div class="name-places-block">
                                <h2>{{selected_tournament.name}}</h2>
                                <p class="places_text">{{selected_tournament.seats.free}} LOCURI DISPONIBILE</p>
                            </div>
                            <div class="content-block">
                                <div class="text-desc">
                                    <div class="adress-block">
                                        <div class="adress-list">
                                            <p>Localitatea<span> - {{selected_tournament.geo.city}}</span></p>
                                            <p>Data: <span>{{selected_tournament.date.d}} {{$t("strings.MONTH_"+parseInt(selected_tournament.date.m))}}, {{$t("strings.WK_"+parseInt(selected_tournament.date.N))}}</span></p>
                                            <p>Ora începerii:<span> {{selected_tournament.date.H}}:{{selected_tournament.date.i}}</span></p>
                                            <p>Locație: <span>{{selected_tournament.geo.address_alt}}</span></p>
                                            <p>Adresa: <span>{{selected_tournament.geo.address}}</span></p>
                                        </div>
                                    </div>
                                    <div class="t-time-block">
                                        <h3 v-if="selected_tournament.game.type">{{$t("tournaments.LBL_TYPE_"+selected_tournament.game.type.toUpperCase())}}<span>{{selected_tournament.game.rhythm.min}} min + {{selected_tournament.game.rhythm.sec}} sec</span></h3>
                                        <p>Ritm de joc: {{selected_tournament.game.rhythm.min}} min pentru partidă fiecărui participant + {{selected_tournament.game.rhythm.sec}} sec. la mutare</p>
                                    </div>
                                    <div class="t-rating-block">
                                        <p>Rating Minim:<span>{{selected_tournament.rating.min=='initial'?$t("tournaments.LBL_INITIAL_RATING"):selected_tournament.rating.min}}</span></p>
                                        <p>Rating Maxim:<span>{{selected_tournament.rating.max=='initial'?$t("tournaments.LBL_INITIAL_RATING"):selected_tournament.rating.max}}</span></p>
                                        <p v-if="selected_tournament.age_from">Limita de vîrstă:<span>a.n. {{selected_tournament.age_from}} și mai mici</span></p>
                                    </div>
                                    <a @click="show_popup_participant=true" class="link">Lista participanților</a>
                                </div>
                                <div class="t-img-price">
                                    <div class="border_div">
                                        <div v-if="selected_tournament.attachments.thumbnail" class="image-container">
                                            <img :src="selected_tournament.attachments.thumbnail" />
                                        </div>
                                        <div v-if="selected_tournament.attachments.thumbnail" class="detail-link">
                                            <div>
                                                <span>Detalii</span>
                                                <div class="description-text" v-html="selected_tournament.description"></div>
                                            </div>
                                        </div>
                                        <p v-else class="description_text" v-html="selected_tournament.description"></p>
                                        <template v-if="archived==false">
                                            <template v-if="selected_tournament.offer.currency">
                                                <div class="t_price_text" v-if="selected_tournament.offer.price.discount">
                                                    <p class="p_cut">{{formatPrice(round2(selected_tournament.offer.price.regular),selected_tournament.offer.currency)}}</p>
                                                    <p class="p_no_cut">{{formatPrice(round2(selected_tournament.offer.price.sale),selected_tournament.offer.currency)}}</p>
                                                </div>
                                                <div class="t_price_text" v-else>
                                                    <p class="price">{{formatPrice(round2(selected_tournament.offer.price.regular),selected_tournament.offer.currency)}}</p>
                                                </div>
                                            </template>
                                            <p class="sale_1" v-if="selected_tournament.offer.price.discount">Reducere {{selected_tournament.offer.price.discount}}% <template v-if="selected_tournament.offer.price.until">până pe {{selected_tournament.offer.price.until.d}} {{$t("strings.MONTH_"+parseInt(selected_tournament.offer.price.until.m))}}</template></p>
                                            <div class="reg_button">
                                                <button class="button" @click="mk_order">Cumpără</button>
                                            </div>
                                        </template>
                                        <template v-if="archived">
                                            <div class="CTA-block">
                                                <h3>CTA Vreai să participi?</h3>
                                                <p>Aici va merge un text care va indemna utilizatorul sa participe la un turneu,la apasarea butonului Participă va merge la pagina cu turneele online</p>
                                            </div>
                                            <div class="reg_button">
                                                <button class="button">Participă</button>
                                            </div> 
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="fother-share-tournament-block" v-if="!selected_tournament.ranking || selected_tournament.ranking.length==0">
                                <div class="fother-text">
                                    <p>Distribuie Turneul</p>
                                    <img src="@/assets/img/mission.png" alt="">
                                </div>
                                <div class="retele-img">
                                    <a :href="share_od" target="_blank"><img src="@/assets/img/odno.png" alt=""></a>
                                    <a :href="share_fb" target="_blank"><img src="@/assets/img/facebook.png" alt=""></a>
                                    <a :href="share_ld" target="_blank"><img src="@/assets/img/010-linkedin.png" alt=""></a>
                                    <a :href="share_vk" target="_blank"><img src="@/assets/img/vk.png" alt=""></a>
                                    <a :href="share_tw" target="_blank"><img src="@/assets/img/twitter.png" alt=""></a>
                                </div>
                            </div>
                        </div>
                        <div class="clasament" v-if="selected_tournament.ranking && selected_tournament.ranking.length>0">
                            <h2 class="popup_head_text">Clasamentul final <img src="@/assets/img/trophy.png" alt=""></h2>
                            <div class="clasament_table">
                                <table class="table">
                                    <tr>
                                        <th width="3%">Locul</th>
                                        <th width="3%">Nr.Inițial</th>
                                        <th>Numele</th>
                                        <th width="3%">Puncte</th>
                                        <th>BH</th>
                                    </tr>
                                    <tr v-for="(rank,index) in selected_tournament.ranking">
                                        <td>{{rank.final}}</td>
                                        <td>{{rank.index}}</td>
                                        <td>{{rank.name}}</td>
                                        <td>{{rank.errors}}</td>
                                        <td>{{rank.bh}}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="fother-share-tournament-block">
                                <div class="fother-text">
                                    <p>Distribuie Turneul</p>
                                    <img src="@/assets/img/mission.png" alt="">
                                </div>
                                <div class="retele-img">
                                    <a :href="share_od" target="_blank"><img src="@/assets/img/odno.png" alt=""></a>
                                    <a :href="share_fb" target="_blank"><img src="@/assets/img/facebook.png" alt=""></a>
                                    <a :href="share_ld" target="_blank"><img src="@/assets/img/010-linkedin.png" alt=""></a>
                                    <a :href="share_vk" target="_blank"><img src="@/assets/img/vk.png" alt=""></a>
                                    <a :href="share_tw" target="_blank"><img src="@/assets/img/twitter.png" alt=""></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="white_container">
                        <div class="tournaments-empty">La moment nu există turnee offline</div>
                    </div>
                </template>
            </template>
            <div v-show="is_loading" class="loading">
                <LoadingIndicator
                    v-if="is_loading"
                    style="position: absolute; width: 2rem; height: 2rem"
                    class="loading-indicator"
                />
            </div>
        </div>
        <Popup :show="show_popup_participant" v-on:closeEvent="()=>{show_popup_participant=false;}" class="participant">
            <template>
                <div class="clasament">
                    <template v-if="selected_tournament.orders && selected_tournament.orders.length>0">
                        <h2 class="popup_head_text">Lista participanților</h2>
                        <div class="clasament_table">
                            <table class="table" v-if="selected_tournament.orders && selected_tournament.orders.length>0">
                                <tr>
                                    <th>Nume</th>
                                </tr>
                                <tr v-for="(order,index) in selected_tournament.orders">
                                    <td>{{order.name}}</td>
                                </tr>
                            </table>
                        </div>
                    </template>
                    <template v-else>
                        <div class="popup-entire-content">
                            <h2 class="popup_head_text">La moment nu sunt persoane înregistrate</h2>
                        </div>
                    </template>
                </div>
            </template>
        </Popup>
        <PayMethodPopup
            :show="showPayMethodPopup"
            :selectedProduct="selectedProduct"
            v-on:paymentEvent="paymentFlowRedirectRequest"
            v-on:closeEvent="showPayMethodPopup = !showPayMethodPopup">
        </PayMethodPopup>
    </div>
    
</template>
<style scoped lang="scss">
.tournaments-primary-container{
    .tabs-view-container{
        margin-bottom: 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        .tabs-wrapper-view{
            display: flex;
            align-items: flex-start;
            justify-content: center;
            width:100%;
            flex:1;
            flex-direction: column;
            @media(max-width:900px){
                align-items: center;
            }
        }
        .tabs-view{
            display: flex;
            >.tab{
                border-bottom: 2px solid #BDBDBD;
                font-style: normal;
                font-weight: normal;
                font-size: 18px;
                line-height: 23px;
                color: #595959;
                letter-spacing: normal;
                font-family: FuturaPT;
                padding:8px 17px;
                cursor: pointer;
                &.active{
                    color:#CF0920;
                    border-color:#CF0920;
                }
            }
        }
        .mobile-prev-button{
            width:30px;
            height:30px;
            background: #E4E9F1;
            border-radius: 100px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            display: none;
            position: relative;
            >.prev-button{
                display: flex;
                align-items: center;
                justify-content: center;
                &:before,&:after{
                    content:"";
                    display: block;
                    background: #a3a9b3;
                    width:10px;
                    height:2px;
                    position: absolute;
                }
                &:before{
                    transform:rotate(45deg);    
                    top: 17px;
                    left: 9px;
                }
                &:after{
                    transform:rotate(-45deg);    
                    top: 11px;
                    left: 9px;
                }
            }
            @media(max-width:900px){
                display:flex;
            }
        }
    }
    .tournaments_container{
        width: 100%;
        display: flex;
        flex-direction: row;
        margin-bottom: 50px;
        min-height: calc(100vh-300px);
        .tournaments_list{
            width: 100%;
            max-width: 352px;
            overflow: scroll;
            overflow-x: hidden;
            .tournament{
                width: 100%;
                background: #FFFF;
                height: 80px;
                border-radius: 10px;
                display: flex;
                align-items: center;
                margin-bottom: 8px;
                cursor: pointer;
                .t-date{
                    padding: 0px 16px 0px 16px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    h2{
                        font-size: 32px;
                        line-height: 40px;
                        color: rgba(11, 16, 34, 0.3);
                    }
                    h4{
                        color: rgba(11, 16, 34, 0.3);
                        font-size: 16px;
                        line-height: 19px;
                        text-transform: uppercase;
                    }
                }
                .t-descrption{
                    .t-name{
                        font-size: 16px;
                        line-height: 16px;
                        color: #0B1022;
                        font-weight: bold;
                    }
                    .t-locuri{
                        font-size: 16px;
                        line-height: 16px;
                        color: #0B1022;
                        margin-top: 9px;
                    }
                }
                &.selected{
                    background: #CF0920;
                    box-shadow: none !important;
                    .t-date h2,.t-date h4{
                        color:#e7848f;
                    }
                    .t-descrption p{
                        color:#fff;
                    }
                }
                &:hover{
                    box-shadow: 0px 2px 4px #c8c8c8;
                }
            }
            @media(max-width:900px){
                max-width: 100%;
            }
        }
        .tournaments-description-container{
            width:100%;
            flex:1;
            padding-left: 16px;
            max-width: 1200px;
            .tournaments_desctription{
                width: 100%;
                flex:1;
                background: #FFFFFF;
                border-radius: 20px;
                padding: 32px 32px 32px 32px;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                .name-places-block{
                    display: flex;
                    flex-direction: row;
                    h2{
                        font-size: 32px;
                        line-height: 37px;
                        letter-spacing: 1px;
                        color: #0B1022;
                        margin-bottom: 16px;
                        width:100%;
                        flex:1;
                        padding-right: 30px;
                    }
                    .places_text{
                        font-size: 16px;
                        letter-spacing: 0.5px;
                        color: rgba(11, 16, 34, 0.3);
                        text-align: end;
                    }
                    @media(max-width:1200px){
                        flex-direction: column-reverse;
                    }
                    @media(max-width:600px){
                        text-align: center;
                        align-items: center;
                        margin-bottom: 30px;
                    }
                }
                .content-block{
                    display: flex;
                    .text-desc{
                        margin-right: 12px;
                        width:100%;
                        max-width: 500px;
                        .adress-block{
                            background: #FFFFFF;
                            border: 1px solid #F0F3F8;
                            border-radius: 10px;
                            .adress-list{
                                padding: 16px;
                                p{
                                    color: #828282;
                                    font-size: 16px;
                                    line-height: 19px;
                                    letter-spacing: 0.5px;
                                    margin-bottom: 4px;
                                    span{
                                        color: #000000;
                                        
                                    }
                                }
                            }
                        }
                        .t-time-block{
                            width: 100%;
                            background: #FFFFFF;
                            border: 1px solid #F0F3F8;
                            border-radius: 10px;
                            padding: 16px;
                            margin-top: 12px;
                            h3{
                                font-size: 16px;
                                line-height: 20px;
                                letter-spacing: 0.5px;
                                color: #000000;
                                span{
                                    font-size: 16px;
                                    line-height: 20px;
                                    letter-spacing: 0.5px;
                                    color: #000000;
                                    margin-left: 7px;
                                }
                            }
                            p{
                                font-size: 16px;
                                line-height: 20px;
                                letter-spacing: 0.5px;
                                color: #333333;
                                margin-top: 7px;
                            }
                        }
                        .t-rating-block{
                            background: #FFFFFF;
                            border: 1px solid #F0F3F8;
                            border-radius: 10px;
                            padding: 5px;
                            margin-top: 10px;
                            p{
                                font-size: 16px;
                                line-height: 19px;
                                letter-spacing: 1px;
                                color: #979797;
                                padding: 5px;
                                span{
                                    color: #000;
                                    margin-left: 7px;
                                }
                            }

                        }
                        .link{
                            font-size: 16px;
                            letter-spacing: 1px;
                            text-decoration-line: underline;
                            color: #000000;
                            margin-top: 16px;
                            cursor: pointer;
                            display: inline-block;
                        }
                    }
                    .t-img-price{
                        width: 100%;
                        max-width: 600px;
                        .border_div{
                            background: #FFFFFF;
                            border: 1px solid #F0F3F8;
                            border-radius: 10px;
                            .image-container{
                                overflow: hidden;
                                border-top-left-radius: 10px;
                                border-top-right-radius: 10px;
                                >img{
                                    max-width: 100%;
                                    height: auto;
                                }
                            }
                            .detail-link{    
                                font-style: normal;
                                font-weight: normal;
                                font-size: 18px;
                                line-height: 23px;
                                color: #595959;
                                letter-spacing: normal;
                                font-family: FuturaPT;

                                display: flex;
                                margin: 0px auto;
                                text-align: center;
                                justify-content: center;
                                align-items: center;
                                >div{
                                    cursor: pointer;
                                    display: flex;
                                    margin: 0px auto;
                                    text-align: center;
                                    justify-content: center;
                                    align-items: flex-start;
                                    z-index: 2;
                                    >span{
                                        text-decoration: underline;
                                    }
                                    >.description-text{
                                        display: none;
                                        position: absolute;
                                        background: #fff;
                                        padding: 15px;
                                        border: none;
                                        border-radius: 10px;
                                        color:#b6b8bd;    
                                        box-shadow: 0px 2px 4px #c8c8c8;    
                                        margin-top: 30px;
                                        max-width: 360px;
                                    }
                                    &:hover{
                                        >span{
                                            color:#CF0920;
                                        }
                                        >.description-text{
                                            display: block;
                                        }
                                    }
                                }
                            }
                            .description_text{
                                width: 100%;
                                font-size: 16px;
                                line-height: 20px;
                                letter-spacing: 0.5px;
                                color: rgba(11, 16, 34, 0.3);
                                padding: 24px;
                            }
                            .t_price_text{
                                display: flex;
                                justify-content: center;
                                margin-top: 34px;
                                .p_cut{
                                    font-size: 16px;
                                    line-height: 19px;
                                    letter-spacing: 1px;
                                    text-decoration-line: line-through;
                                    color: #0B1022;
                                    display: flex;
                                    align-items: center;
                                    margin-right: 9px;
                                }
                                .p_no_cut{
                                    font-size: 24px;
                                    line-height: 28px;
                                    letter-spacing: 0.75px;
                                    color: #CF0920;
                                    font-weight: bold;
                                }
                                p.price{
                                    font-size: 16px;
                                    line-height: 19px;
                                    letter-spacing: 1px;
                                    color: #0B1022;
                                    display: flex;
                                    align-items: center;
                                }
                            }
                            .sale_1{
                                font-size: 16px;
                                line-height: 20px;
                                text-align: center;
                                letter-spacing: 0.5px;
                                color: #595959;
                            }
                            .reg_button{
                                display: flex;
                                justify-content: center;
                                margin-top: 24px;
                                margin-bottom: 24px;
                                .button{
                                    width: 160px;
                                    height: 40px;
                                    font-size: 16px;
                                    line-height: 20px;
                                    padding: 0px;
                                }
                            }
                            .CTA-block{
                                padding: 16px 20px 0px 20px;
                                h3{
                                    font-family: FuturaPT;
                                    font-size: 16px;
                                    line-height: 20px;
                                    letter-spacing: 0.5px;
                                    color: #000000;
                                }
                                p{
                                    font-size: 16px;
                                    line-height: 20px;
                                    letter-spacing: 0.5px;
                                    color: #4F4F4F;
                                    margin-top: 7px;
                                }
                            }
                        }
                    }
                    @media(max-width:1147px){
                        display: grid;
                        grid-template-columns: repeat(1,1fr);
                        grid-gap: 30px;
                        .t-img-price{
                        }
                        .text-desc{
                            margin-right: 0px;
                            display: grid;
                            grid-template-columns: repeat(1,1fr);
                            grid-gap: 10px;
                        }
                    }
                }
                .fother-share-tournament-block{
                    width: 100%;
                    min-height: 72px;
                    background: #FFFFFF;
                    border: 1px solid #F0F3F8;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 56px;
                    .fother-text{
                        display: flex;
                        align-items: center;
                        margin-left: 32px;
                        p{
                            font-size: 16px;
                            line-height: 20px;
                            letter-spacing: 0.5px;
                            color: #333333;
                        }
                        img{
                            margin-left: 8px;
                        }
                    }
                    .retele-img{
                        margin-right: 32px;
                        a{
                            margin-left: 16px;
                        }
                    }
                    @media(max-width:1200px){
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        padding: 30px;
                        .fother-text{
                            margin:0px 0px 15px 0px;
                        }
                        .retele-img{
                            margin:0px;
                            display: grid;
                            grid-template-columns: repeat(5,1fr);
                            grid-gap:10px;
                            >a{
                                display: flex;
                                cursor: pointer;
                                align-content: center;
                                justify-content: center;
                                margin:0px;
                            }
                        }
                    }
                }

                @media(max-width:580px){
                    padding: 32px 14px 32px 14px;
                    .name-places-block{
                        flex-direction: column;
                    }
                    .content-block{
                        flex-direction: column;
                        align-items: center;
                    }
                    .fother-share-tournament-block{
                        flex-direction: column;
                        .fother-text{
                            margin-top: 34px;
                            margin-bottom: 26px;
                        }
                        .retele-img{
                            margin-bottom: 20px;
                        }
                    }
                }
            }
            .clasament{
                width: 100%;
                background: #FFFFFF;
                border-radius: 20px;
                margin-top: 16px;
                padding: 0px 32px 32px;
                .popup_head_text{
                    font-size: 32px;
                    line-height: 40px;
                    letter-spacing: 1px;
                    color: #0B1022;
                    text-align: center;
                    padding: 32px;
                }
                .clasament_table{
                    .table{
                        width: 100%;
                        max-width: 900px;
                        border-radius: 10px;
                        margin: 0 auto;
                        th{
                            height: 48px;
                            font-family: FuturaPT;
                            font-size: 16px;
                            line-height: 19px;
                            letter-spacing: 0.5px;
                            color: #848894;
                        }
                        td{
                            height: 48px;
                            font-family: FuturaPT;
                            font-size: 16px;
                            line-height: 19px;
                            letter-spacing: 0.5px;
                            color: #000000;
                        }
                        th,td{
                            padding:0px 10px;
                        }
                    }
                    .table, tr, th, td{ 
                        border: 1px solid #F0F3F8;
                        border-collapse: collapse;
                        text-align: center;
                    }
                    @media(max-width:425px){
                        .table{
                            th{
                                font-size: 13px;
                            }
                            td{
                                height: 35px;
                                font-size: 11px;
                            }
                        }
                    }
                }
                .fother-share-tournament-block{    
                    width: 100%;
                    max-width: 900px;
                    min-height: 72px;
                    background: #FFFFFF;
                    border: 1px solid #F0F3F8;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin: 56px auto 0px auto;
                    .fother-text{
                        display: flex;
                        align-items: center;
                        margin-left: 32px;
                        p{
                            font-size: 16px;
                            line-height: 20px;
                            letter-spacing: 0.5px;
                            color: #333333;
                        }
                        img{
                            margin-left: 8px;
                        }
                    }
                    .retele-img{
                        margin-right: 32px;
                        a{
                            margin-left: 16px;
                        }
                    }
                    @media(max-width:1200px){
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        padding: 30px;
                        .fother-text{
                            margin:0px 0px 15px 0px;
                        }
                        .retele-img{
                            margin:0px;
                            display: grid;
                            grid-template-columns: repeat(5,1fr);
                            grid-gap:10px;
                            >a{
                                display: flex;
                                cursor: pointer;
                                align-content: center;
                                justify-content: center;
                                margin:0px;
                            }
                        }
                    }
                }
                @media(max-width:500px){
                    padding:0px 15px 15px 15px;
                }
                @media(max-width:425px){
                    .popup_head_text{
                        font-size: 17px;
                    }
                }
            }

            @media(max-width:900px){
                padding-left:0px;
            }
        }
        div.loading{
            display: flex;
            align-content: center;
            justify-content: center;
            width:100%;
        }
        
        @media(max-width:900px){
            &:not(.list-displayed){
                .tournaments_list{
                    display: none;
                }
                .tournaments-description-container{
                    display:block;
                }
            }
            &.list-displayed{
                .tournaments_list{
                    display: block;
                }
                .tournaments-description-container{
                    display:none;
                }
            }
        }
    }
    .tournaments-empty{
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        padding: 60px;
        font-family: FuturaPT;
        font-size: 32px;
        line-height: 37px;
        letter-spacing: 1px;
        color: #0B1022;
        min-height: 50vh;
    }
    .participant{
        .clasament{
            width: 100%;
            .popup_head_text{
                font-size: 32px;
                line-height: 40px;
                letter-spacing: 1px;
                color: #0B1022;
                text-align: center;
                padding: 32px;
            }
            .clasament_table{
                .table{
                    width: 100%;
                    max-width: 400px;
                    border-radius: 10px;
                    margin: 0 auto;
                    th{
                        height: 48px;
                        font-family: FuturaPT;
                        font-size: 16px;
                        line-height: 19px;
                        letter-spacing: 0.5px;
                        color: #848894;
                    }
                    td{
                        height: 48px;
                        font-family: FuturaPT;
                        font-size: 16px;
                        line-height: 19px;
                        letter-spacing: 0.5px;
                        color: #000000;
                    }
                    th,td{
                        padding:0px 10px;
                    }
                }
                .table, tr, th, td{ 
                    border: 1px solid #F0F3F8;
                    border-collapse: collapse;
                    text-align: center;
                }
                @media(max-width:425px){
                    .table{
                        width: 355px;
                        th{
                            font-size: 13px;
                        }
                        td{
                            height: 35px;
                            font-size: 11px;
                        }
                    }
                }
            }
        }
        .popup-entire-content{
            display: flex;
            align-content: center;
            justify-content: center;
            flex-direction: column;
            height:100%;
        }
    }
}
</style>
<script>
    import Popup from '@/components/Popup';
    import {rest,formatPrice} from '@/utils/utils';
    import store from '@/store';
    import i18n from '@/i18n';
    import PayMethodPopup from '@/views/pages/shop/popups/PayMethodPopup';
    import { mapGetters, mapActions } from 'vuex';
    import LoadingIndicator from '@/components/LoadingIndicator/LoadingIndicator';
import { decodeHtml } from '../../../utils/utils';
    
    export default {
        name: "TournamentsOffline",
        components: {
            Popup,
            PayMethodPopup,
            LoadingIndicator
        },
        data: function () {
            return {
                show_popup_participant:false,
                archived:false,
                tournaments:[],
                selected:null,
                showPayMethodPopup:false,
                selectedProduct:null,
                is_loading:true,
                show_tournaments_list:true,
            }
        },
        mounted(){
            this.get();
        },
        computed:{
            ...mapGetters({
                user: 'user/get',
            }),
            selected_tournament(){
                for(var x in this.tournaments){
                    if(this.tournaments[x].id==this.selected){
                        return this.tournaments[x];
                    }
                }
                return {
                    name:"",
                    seats:{},
                    geo:{},
                    date:{},
                    rating:{},
                    ranking:[],
                    game:{
                        rhythm:{}
                    },
                    attachments:{},
                    offer:{
                        ribbon:{
                            title:null,
                            icon:null
                        },
                        price:{
                            discount:null,
                            regular:null,
                            sale:null,
                            unit:null,
                        }
                    },
                    clients:[]
                };
            },
            tournament_url(){
                return (window.location.origin+"/tournaments/offline?tournament="+this.selected_tournament.id);
            },
            share_od(){
                return "https://connect.ok.ru/offer?url="+encodeURIComponent(this.tournament_url)+"&title="+encodeURIComponent(this.selected_tournament.name);
            },
            share_fb(){
                return "http://www.facebook.com/sharer.php?u="+encodeURIComponent(this.tournament_url);
            },
            share_ld(){
                return "https://www.linkedin.com/shareArticle?mini=true&url="+encodeURIComponent(this.tournament_url)+"&title="+encodeURIComponent(this.selected_tournament.name)+"&summary="+encodeURIComponent(this.selected_tournament.description)+"&source="+encodeURIComponent(this.tournament_url);
            },
            share_vk(){
                return "http://vk.com/share.php?&url="+encodeURIComponent(this.tournament_url)+"&title="+encodeURIComponent(this.selected_tournament.name)+"&description="+encodeURIComponent(this.selected_tournament.description);
            },
            share_tw(){
                return "http://twitter.com/share?url="+encodeURIComponent(this.tournament_url)+"&text="+encodeURIComponent(this.selected_tournament.name);
            },
        },
        methods: {
            get(){
                store.commit('loading/is', true);
                this.tournaments = [];
                this.is_loading = true;
                rest.call("get_tournaments",{
                    "type":"online",
                    "archived":this.archived,
                    "query":this.selected?null:this.$route.query.tournament
                },"GET").then((response)=>{
                    this.$route.query.tournament = null;
                    this.selected=null;
                    store.commit('loading/is', false);
                    this.is_loading = false;
                    if(response.status && response.status == "ok" && response.list){
                        this.tournaments = response.list;
                        for(var x in response.list){
                            if(this.$route.query){
                                if(this.$route.query.tournament){
                                    if(response.list[x].id == this.$route.query.tournament){
                                        this.selected = response.list[x].id;
                                        break;
                                    }
                                }
                            }
                        }
                        if(!this.selected){
                            for(var x in response.list){
                                this.selected = response.list[x].id;
                                break;
                            }
                        }
                        if(response.archived && response.query){
                            this.archived = response.archived;
                        }
                    }
                }).catch((error)=>{
                    store.commit('loading/is', false);
                    this.is_loading = false;
                });
            },
            round2(num){
                return num;
            },
            formatPrice(value,currency=null){
                currency = currency?currency:this.user.currency;
                return formatPrice(value,currency);
            },
            /**
             * Открывает диалог оплаты
             */
            mk_order(){
                this.selectedProduct = this.selected_tournament.offer;
                this.showPayMethodPopup = true;
            },
            /**
             * Заказ товара
             */
            paymentFlowRedirectRequest(paymentInfo) {
                store.commit('loading/is', true);
                rest.call("proccess_offer",{
                    "product":paymentInfo.id,
                    "method":paymentInfo.payment_method,
                    "currency":this.user.currency,
                    "rate":paymentInfo.rateEURtoLEI,
                    "qty":paymentInfo.qty,
                    "offer":paymentInfo.offer,
                    "offer_product_id":paymentInfo.offer_product_id,
                    "promocode":paymentInfo.promocode
                },"GET").then((response)=>{
                    store.commit('loading/is', false);
                    if(response.status && response.redirect){
                        window.location.href = decodeHtml(response.redirect);
                        window.location.replace(decodeHtml(response.redirect));
                        store.commit('loading/is', false);
                        return;
                    }
                }).catch((error)=>{
                    store.commit('loading/is', false);
                });
            }
        },
        watch:{
            archived(){
                this.get();
            }
        }
    }
</script>